
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, CircularProgress, } from '@material-ui/core';
import MatchHeader from './MatchHeader';
import MatchTitle from './MatchTitle';
import Apis from '../../network/Apis';
import DateUtils from '../../control/dateutils';
import NoMatch from '../home/NoMatch';
import { MatchItem } from './view';
import Match from '../../model/Match';
import AppData from '../../model/AppData';
import { ListView, PullToRefresh } from 'antd-mobile';
import AppUtils from '../../control/apputlis';
import MStatusBar from '../view/MStatusBar';
import MEnvelope from '../view/MEnvelope';

const PAGE_SIZE = 10;

class MatchPage extends React.Component {

    constructor(props) {
        super(props);
        let tabIndex = AppUtils.getStorageInt(AppUtils.MATCH_SELECTED_TAB_INDEX);
        let typeIndex = AppUtils.getStorageInt(AppUtils.MATCH_SELECTED_TYPE_INDEX);

        console.log('tabIndex', tabIndex, typeIndex);

        this.state = {
            tabIndex: tabIndex,
            typeIndex: typeIndex,
            oneTypeData: [],
            data: [],
            matchsData: [],
            allData: [],
            isRefreshing: false,
            pageNow: 1,
        };
        this.dateTime = DateUtils.getCurTime() / 1000;
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'MatchPage');
        AppData.checkUpdate();
        let oneTypeData = AppData.getSchedusTypeData();
        if (oneTypeData.length == 0) {
            this.getShowOneType();
        } else {
            this.setState({ oneTypeData: oneTypeData }, () => {
                let index = this.state.typeIndex < oneTypeData.length ? this.state.typeIndex : 0;
                this.getMatchs(oneTypeData[index]);
            });
        }
    }

    componentWillUnmount() {
        AppUtils.setStorageItem(AppUtils.MATCH_SELECT_TIMER, 0);
        this.setState = () => false;
    }

    getShowOneType = async () => {
        let result = await Apis.encryptionShowOneType();
        if (result.code == 200) {
            AppData.setSchedusTypeData(result.data);
            this.setState({ oneTypeData: result.data });
            if (result.data.length != 0) {
                let index = this.state.typeIndex < result.data.length ? this.state.typeIndex : 0;
                this.getMatchs(result.data[index]);
            }
        }
    }

    getMatchs = async (val) => {
        let timer = AppUtils.getStorageInt(AppUtils.MATCH_SELECT_TIMER);
        this.filerMatchs(AppData.getSchedusMatchData(val.type_id));
        let result = await Apis.encryptionMatch(val.type_id, timer == 0 ? undefined : timer);
        console.log(result);
        if (result.code == 200) {
            this.state.matchsData = result.data;
            AppData.setSchedusMatchData(val.type_id, result.data);
            this.filerMatchs(this.state.matchsData, this.state.tabIndex);
        }

    }

    _handleChange = (val) => {
        const { oneTypeData } = this.state;
        let i = 0;
        for (; i < oneTypeData.length; i++) {
            if (oneTypeData[i].type_id == val.type_id) {
                break;
            }
        }
        this.state.typeIndex = i;
        AppUtils.setStorageItem(AppUtils.MATCH_SELECTED_TYPE_INDEX, this.state.typeIndex);
        this.getMatchs(val);
    }

    _handleStatus = (val) => {
        console.log('_handleStatus', val);
        this.state.pageNow = 1;
        AppUtils.setStorageItem(AppUtils.MATCH_SELECT_TIMER, 0);
        AppUtils.setStorageItem(AppUtils.MATCH_SELECTED_TAB_INDEX, val);
        this.setState({ tabIndex: val, pageNow: 1 });
        this.filerMatchs(this.state.matchsData, val);
    }

    filerMatchs = (data, tabIndex) => {
        const { oneTypeData } = this.state;
        if (!oneTypeData || oneTypeData.length == 0) return;

        let type_id = oneTypeData[this.state.typeIndex].type_id;
        let sdata = [];
        let living = [];
        let noStart = [];
        let finish = [];
        let others = [];
        data.forEach(element => {
            let match = new Match(element);
            if (tabIndex == 0) {
                if (match.living()) {
                    living.push(element);
                } else if (match.notStarted()) {
                    noStart.push(element);
                } else if (match.finished()) {
                    finish.push(element);
                } else {
                    others.push(element);
                }
                // sdata.push(element);
            } else if (tabIndex == 1) {
                if (match.living()) {
                    sdata.push(element);
                }
            } else if (tabIndex == 2) {
                if (match.notStarted()) {
                    sdata.push(element);
                }
            } else if (tabIndex == 3) {
                if (match.finished()) {
                    sdata.push(element);
                }
            } else if (tabIndex == 4) {
                if (AppData.isStarMatch(type_id, match.id)) {
                    sdata.push(element);
                }
            }
        });
        if (tabIndex == 3) {
            sdata = sdata.reverse();
        } else if (tabIndex == 0) {
            living.forEach(element => {
                sdata.push(element)
            });
            noStart.forEach(element => {
                sdata.push(element)
            });
            finish.forEach(element => {
                sdata.push(element)
            });
            others.forEach(element => {
                sdata.push(element)
            });
        }

        let filterData = AppUtils.getStorageObj(AppUtils.MATCH_SELECTED + type_id);
        if (filterData && filterData.length > 0) {
            sdata = sdata.filter((item) => {
                let isExast = false;
                for (let i = 0; i < filterData.length; i++) {
                    if (filterData[i].competition_id == item.competition_id) {
                        isExast = true;
                    }
                }
                return isExast;
            })
        }

        this.state.allData = sdata;
        this._showPageData(sdata);
    }

    _showPageData = (data) => {
        let all = PAGE_SIZE * this.state.pageNow;
        let tmpData = data.slice(0, all);
        this.setState({ data: tmpData });
    }


    _onRefresh = () => {

    }

    _handleTimer = () => {
        const { oneTypeData } = this.state;
        let type_id = oneTypeData[this.state.typeIndex].type_id;
        this.props.history.push({ pathname: '/matchcalendar/' + type_id });
    }

    _onEndReached = () => {
        this.state.pageNow++;
        if ((this.state.pageNow + 1) * PAGE_SIZE < this.state.allData.length) {
            this._showPageData(this.state.allData);
        }
    }

    _renderFooter = () => {
        return (<Grid style={{ height: 100 }}></Grid>);
    }

    _renderHeader = () => {
        return (
            <Grid container direction='column' alignItems='center'>
                <MStatusBar />
            </Grid>
        );
    }

    _renderItem = (item) => {
        return (
            <MatchItem line={true} data={item} />
        )
    }

    render() {
        const { classes } = this.props;
        const { data, oneTypeData, isRefreshing, typeIndex, tabIndex } = this.state;
        const ds = new ListView.DataSource({
            rowHasChanged: (r1, r2) => r1 !== r2
        });

        let marginTop = 82;
        if (tabIndex == 2 || tabIndex == 3) {
            marginTop += 30;
        }
        let heightstr = 'calc(100vh - ' + marginTop + 'px)';

        return (
            <Grid container direction='column' alignItems='center' className={classes.list}>
                <Grid container direction='column' alignItems='center' style={{ position: 'fixed', zIndex: 100, backgroundColor: '#FFF' }} >
                    <MStatusBar />
                    <MatchHeader value={typeIndex} data={oneTypeData} onChange={(val) => this._handleChange(val)} />
                    <MatchTitle value={tabIndex} onChange={(val) => this._handleStatus(val)} onTimer={() => this._handleTimer(tabIndex)} />
                </Grid>
                <Grid container direction='column' alignItems='center' style={{ height: heightstr, width: '100vw', marginTop: marginTop }}>
                    {
                        data.length > 0 && <ListView
                            initialListSize={data.length}
                            listPrefixCls='padding: 0px'
                            style={{ width: '100%', height: heightstr, paddingTop: 8 }}
                            contentContainerStyle={{ width: '100%', padding: 0 }}
                            dataSource={ds.cloneWithRows(data)}
                            renderRow={this._renderItem}
                            pageSize={10}
                            useBodyScroll={false}
                            renderHeader={this._renderHeader}
                            onEndReached={this._onEndReached}
                            onEndReachedThreshold={10}
                            pullToRefresh={
                                <PullToRefresh
                                    refreshing={isRefreshing}
                                    onRefresh={this._onRefresh}
                                />
                            }
                            renderFooter={this._renderFooter}
                        />
                    }
                    {
                        data.length == 0 && <Grid container justify='center' alignItems='center' style={{ width: '100vw', marginTop: marginTop }}  >
                            <NoMatch />
                        </Grid>
                    }
                    {/* <MEnvelope bottom={123} /> */}
                </Grid>
            </Grid>
        );


    }
}

export default withRouter(withStyles((theme) => ({
    list: {
        width: '100vw',
        margin: theme.spacing(0),
        padding: theme.spacing(0),
    },
}))(MatchPage));